/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.widgets.styled_labels.Rounded
 *  mp.widgets.styled_labels.IconTextless
 *
 * Requires:
 *  mp.widgets.Dropdown
 */

_.namespace(`mp.widgets.styled_labels`, function() {
  'use strict';

  function Rounded() {
    this.class_name = `rounded_dropdown_label`;
  }
  _.inherit(Rounded, mp.widgets.Dropdown.Label);

  Rounded.prototype.create = function(div, config) {
    // creating these so that collapse works
    this.title = $(`<div>`).addClass(`title`);
    this.arrow = $(`<div>`).addClass(`arrow`);

    Rounded.superclass.create.call(this, div, config);

    this.container.append(this.title, this.arrow);

    return this;
  };

  function IconTextless() {
    this.class_name = `icon_textless_label`;
  }
  _.inherit(IconTextless, mp.widgets.Dropdown.Label);

  IconTextless.prototype.create = function(div, config) {
    IconTextless.superclass.create.call(this, div, config);

    this.icon = $(`<div>`).addClass(`icon`);
    this.arrow = $(`<div>`).addClass(`arrow`);

    this.container.append(this.icon, this.arrow);

    return this;
  };

  IconTextless.prototype._set_content = function(item) {
    this.icon.attr({'class': `icon ` + item.value}); // Add the value as a class for easy custom styling
  };

  return {
    Rounded,
    IconTextless,
  };
});

}.call(window));